import { AreaVisitsIcon } from 'src/components/insights/icons/area-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/area-visits-hourly-foot-traffic.png'

const AreaVisitsHourlyFootTrafficCard = dynamic(() => import('src/components/insights/area-visits/hour-of-day'), {
  ssr: false,
})

export const AreaVisitsHourlyFootTrafficWidget: InsightBuilderWidget = {
  id: 'area-visits-hourly-foot-traffic',
  name: 'Area Visits Hourly Foot Traffic',
  type: 'Area Visits',
  icon: AreaVisitsIcon,
  component: AreaVisitsHourlyFootTrafficCard,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
